export const formatWeight = (value) => {
  if (value === "" || value == null) return "";
  const num = parseFloat(value);
  if (num === 100) return `${value}% (Won)`;
  if (num === 0) return `${value}% (Lost)`;
  return `${value}%`;
};

export const parseWeight = (value) => {
  if (!value) return "";
  return value.toString().replace(/[^0-9.]/g, "");
};

export const getProbabilityFromWeight = (weightPercentage) => {
  if (weightPercentage == null || weightPercentage === "") return "OPEN";
  const weight = parseFloat(weightPercentage);
  if (weight === 100) return "WON";
  if (weight === 0) return "LOST";
  return "OPEN";
};

export const validateWeights = (stages) => {
  for (const stage of stages) {
    const value = stage.weightPercentage;

    if (value == null || value === "") {
      return { valid: false, error: "Each stage must have a weight percentage" };
    }

    const weight = parseFloat(value);

    if (isNaN(weight)) {
      return { valid: false, error: "Weight percentage must be a valid number" };
    }

    if (weight < 0 || weight > 100) {
      return { valid: false, error: "Each stage weight must be between 0% and 100%" };
    }
  }

  return { valid: true, error: null };
};
